import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useMoveTaskPhotos = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      propertyId,
      taskText,
      fromRoomName,
      toRoomName,
    }: {
      propertyId: string;
      taskText: string;
      fromRoomName: string;
      toRoomName: string;
    }) => {
      // Update task_reference_photos - change room_name for matching tasks
      const { error: refPhotoError } = await supabase
        .from("task_reference_photos")
        .update({ room_name: toRoomName })
        .eq("property_id", propertyId)
        .eq("room_name", fromRoomName)
        .eq("task_text", taskText);

      if (refPhotoError) throw refPhotoError;

      // Update task_submission_photos - need to join through cleaning_submissions
      // First, get all submission IDs for this property
      const { data: submissions, error: submissionsError } = await supabase
        .from("cleaning_submissions")
        .select("id")
        .eq("property_id", propertyId);

      if (submissionsError) throw submissionsError;

      if (submissions && submissions.length > 0) {
        const submissionIds = submissions.map(s => s.id);
        
        // Update task_submission_photos for these submissions
        const { error: subPhotoError } = await supabase
          .from("task_submission_photos")
          .update({ room_name: toRoomName })
          .in("submission_id", submissionIds)
          .eq("room_name", fromRoomName)
          .eq("task_text", taskText);

        if (subPhotoError) throw subPhotoError;
      }

      return { success: true };
    },
    onSuccess: (_, variables) => {
      // Invalidate relevant queries
      queryClient.invalidateQueries({
        queryKey: ["task-reference-photos", variables.propertyId],
      });
      queryClient.invalidateQueries({
        queryKey: ["task-submission-photos"],
      });
    },
  });
};
